import type { Resource } from "@entities/resources/types";
import {
  FacebookColor,
  Favicon,
  InstagramColor,
  YoutubeColor,
} from "@shared/assets/icons";
import { FunctionComponent } from "react";

export const iconTypeMap = {
  youtube: YoutubeColor,
  instagram: InstagramColor,
  facebook: FacebookColor,
  blog: Favicon,
} satisfies Record<Resource["platform"], FunctionComponent>;

export const aspectRatioMap = {
  youtube: "16/9",
  instagram: "4/5",
  facebook: "16/9",
  blog: "16/9",
} satisfies Record<Resource["platform"], string>;
